import React, { useEffect } from 'react';
import { ToursForToursSectionContext } from '../../context/toursForToursSectionContext';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../../store/app/selectors';
import {
  GET_TOURS_FOR_TOURS_SECTION_AUTHED,
  GET_TOURS_FOR_TOURS_SECTION_UNAUTHED,
} from '../../components/contentSections/toursSection/Tours';

import { useLazyQuery } from '@apollo/client';
import { isMobile } from 'react-device-detect';
import { EXPLORE_WEB_GetToursForToursSectionUnauthed as Data } from '../../components/contentSections/toursSection/__generated__/EXPLORE_WEB_GetToursForToursSectionUnauthed';

type Props = {
  children: React.ReactNode;
};

export const ToursForToursSectionProvider = ({ children }: Props) => {
  const authed = useSelector(selectIsAuthenticated);
  const query = authed
    ? GET_TOURS_FOR_TOURS_SECTION_AUTHED
    : GET_TOURS_FOR_TOURS_SECTION_UNAUTHED;

  const [fetchTours, { loading, data, error }] = useLazyQuery<Data, null>(
    query,
    {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
      // @ts-ignore - Type '{ skipPresentThumbnail: boolean; }' is not assignable to type 'null | undefined'.
      variables: {
        skipPresentThumbnail: isMobile,
      },
    }
  );

  useEffect(() => {
    fetchTours();
  }, [fetchTours, authed]);

  return (
    <ToursForToursSectionContext.Provider
      value={{ fetchTours, loading, data, error }}
    >
      {children}
    </ToursForToursSectionContext.Provider>
  );
};
